<template>
  <header class="flex flex-wrap justify-between items-center px-2 bg-brand border-b border-section_border">
    <div @click="backTop" class="text-white text-lg font-bold">
      お出かけ情報サービス
    </div>
    <div v-if="!isCurrentNotice()">
      <!-- 仮置き（後でアイコンと置換） -->
      <div v-if="getUnreadCount() > 0" class="absolute right-16 top-0 menuIcon mt-1 w-5 text-center text-sm text-white">
        {{getUnreadCount()}}
      </div>
      <button @click="openNotice" class="px-2 py-1 bg-blue-400 text-white font-semibold rounded hover:bg-blue-500">
        MENU
      </button>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
      lang: 'user/getLang',
      notice: 'notice/getAll',
      alreadyRead: 'notice/getAlreadyRead'
    }),
    toPlan: function () {
      if (this.from.name) {
        if (this.from.name == 'root') {
          return {
            name: 'plans'
          }
        } else if ((this.from.name == 'createReservation') || (this.from.name == 'reservation')) {
          return {
            name: 'plans'
          }
        } else if (this.from.name == 'top') {
          return {
            name: 'top',
            params: { lang: this.lang }
          }
        } else {
          return {
            name: this.from.name,
            params: this.from.params
          }
        }
      } else {
        // NOTE: /mapに直接きた場合
        if (this.lang && this.lang !== 'ja') {
          return {
            name: 'top',
            params: { lang: this.lang}
          }
        } else {
          return {
            name: 'plans'
          }
        }
      }
    },
    toMap: function () {
      return {
        name: 'map',
        params: { lang: this.$store.getters['user/getLang'] }
      }
    }
  },
  mounted() {
    this.$store.dispatch('notice/fetchAll')
  },
  methods: {
    mae_maas_url: function () {
      return Constants.LINK_BASE_URL + '/'
    },
    openNotice: function () {
      //お知らせ開く
      this.$router.push( {name: 'notice', params: { lang: this.lang } })
    },
    backTop: function () {
      if (this.$route.path != '/' && this.$route.path != '/'+this.lang) {
        this.$router.push( {name: 'top'})        
      }
    },
    isCurrentNotice: function () {
      return this.$route.name === 'notice'
    },
    getUnreadCount: function () {
      return this.notice.length - this.notice.filter(n => this.alreadyRead.includes(n.id)).length
    }
  },
}
</script>

<style lang="scss" scoped>
.menuIcon {
  border-radius: 50%;
  background-color: rgb(239 68 68);
}
</style>
